<ng-template #modalContent>
  <div class="health-status-content">
    <div class="health-table">
      <div class="table-header">
        <div>
          <i nz-icon nzType="icons:pressure"></i>
          <span>{{ i18n.langString("health_status_title") }}</span>
        </div>

        <div>
          <i nz-icon nzType="icons:tool"></i>
          <span>{{ i18n.langString("RUL_title") }}</span>
        </div>

        <div class="suggestion-icon">
          <i nz-icon nzType="icons:suggestionstatus"></i>
          <span>{{ i18n.langString("Suggestion_title") }}</span>
        </div>
      </div>

      @for (row of healthStatusRows(); track row.status) {
        <div class="table-row">
          <div class="status-cell">
            <i nz-icon [nzType]="row.icon" [class]="row.statusClass"></i>

            <span [class]="row.statusClass">
              {{ row.status }}
            </span>
          </div>

          <div class="rul-cell">
            {{ row.rul }}
          </div>

          <div class="suggestion-cell">
            {{ row.suggestion }}
          </div>
        </div>
      }
    </div>
  </div>

  <!-- Information Card -->

  <div class="info-card">
    <div class="info-content">
      <i nz-icon nzType="icons:info"></i>

      <span>
        {{ i18n.langString("equipment_health_info_details") }}
      </span>
    </div>

    <app-nav-button
      [darksecondary]="true"
      svgIcon="icons:dashboard"
      (clickEvent)="goToNanoPreciseDashboard()"
    >
      {{ i18n.langString("analyst_dashboard") }}
    </app-nav-button>
  </div>
  <div class="buttonwrapper">
    <app-nav-button
      [primary]="true"
      (clickEvent)="cancelClick()"
      [svgIcon]="'icons:fixed'"
    >
      {{ i18n.langString("got_it") }}
    </app-nav-button>
  </div>
</ng-template>

<nz-modal
  [nzVisible]="modalOpen()"
  [nzWidth]="isMobile() ? '95vw' : '684px'"
  [nzCentered]="true"
  [nzFooter]="null"
  [nzContent]="modalContent"
  [nzTitle]="i18n.langString('equipment_health_status')"
  [nzCloseIcon]="'icons:exit'"
  (nzOnCancel)="cancelClick()"
  [nzMaskClosable]="false"
>
</nz-modal>
